import PageLayout from "@/components/base/page-layout";
import withErrorBoundary from "@/components/hoc/with-error-boundary";
import Product from "@/components/products/details";
import useQueryProducts from "@/hooks/queries/useQueryProducts";
import { Params } from "@/types/utils";
import React from "react";
import { useParams } from "react-router-dom";

const ProductPage: React.FC = () => {
  const { pid } = useParams<Params>();
  const { data: products } = useQueryProducts();
  const product = products?.find((p) => p.id === pid);

  if (!product) {
    return null;
  }

  return (
    <PageLayout title="Product details">
      <Product data={product} />
    </PageLayout>
  );
};

export default withErrorBoundary({ component: "ProductPage" })(ProductPage);
